export default __webpack_public_path__ + "static/media/featured-goldman.52356559.webp";